//# sourceMappingURL=answer.mjs.map
/// <reference types="./answer.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $answer from "../../../data_types/data/proposal_element/answer.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $super_admin from "../../admin/effects/super_admin.mjs";
import { apply_org_header } from "../../admin/effects/super_admin.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_answers(proposal_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["proposals", proposal_id, "elements", "answers"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = apply_org_header(_pipe$1, store);
          let _pipe$3 = $ask.expect(
            _pipe$2,
            $decode.list($answer.answer_decoder()),
          );
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (answers) => {
              dispatch(
                new $msg.Proposal(
                  new $msg.ApiReturnedAnswers(proposal_id, answers),
                ),
              );
              return undefined;
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Error fetching answers",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function migrate_proposal_answers(proposal_id) {
  return $effect.from_(
    (dispatch, get_state, dispatch_effect) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Admin(),
            toList(["proposals", proposal_id, "migrate-answers"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Migration done",
              );
              dispatch(_pipe$4);
              let _pipe$5 = fetch_answers(proposal_id);
              return dispatch_effect(_pipe$5);
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Migration failed",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}

export function rollback_answer(proposal_id, answer_id, version_id) {
  return $effect.from_(
    (dispatch, get_state, dispatch_effect) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = $ask.to(
            new $ask.Heimdall(),
            toList(["proposals", proposal_id, "answers", answer_id, "rollback"]),
          );
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
          let _pipe$3 = $ask.json(
            _pipe$2,
            $json.object(toList([["version_id", $json.string(version_id)]])),
          );
          let _pipe$4 = apply_org_header(_pipe$3, store);
          let _pipe$5 = $ask.on_success(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Version restored",
              );
              dispatch(_pipe$5);
              let _pipe$6 = fetch_answers(proposal_id);
              return dispatch_effect(_pipe$6);
            },
          );
          let _pipe$6 = $ask.on_error(
            _pipe$5,
            (_) => {
              let _pipe$6 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Rollback failed",
              );
              return dispatch(_pipe$6);
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}

export function migrate_answer(proposal_id, element_id, answer_id) {
  return $effect.from_(
    (dispatch, get_state, dispatch_effect) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let at = toList([
            "admin",
            "proposals",
            proposal_id,
            "elements",
            element_id,
            "answer",
            answer_id,
            "tov2",
          ]);
          let _pipe = $ask.to(new $ask.Heimdall(), at);
          let _pipe$1 = $ask.bearing(_pipe, access_token);
          let _pipe$2 = $ask.via(_pipe$1, new $http.Post());
          let _pipe$3 = apply_org_header(_pipe$2, store);
          let _pipe$4 = $ask.on_success(
            _pipe$3,
            (_) => {
              let _pipe$4 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Success(),
                "Answer migrated",
              );
              dispatch(_pipe$4);
              let _pipe$5 = fetch_answers(proposal_id);
              return dispatch_effect(_pipe$5);
            },
          );
          let _pipe$5 = $ask.on_error(
            _pipe$4,
            (_) => {
              let _pipe$5 = new $msg.ApplicationRequestedToDisplayToast(
                new $toast.Error(),
                "Error fetching answers",
              );
              return dispatch(_pipe$5);
            },
          );
          return $ask.run(_pipe$5);
        },
      );
    },
  );
}
